import set from 'lodash/set';

import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';
import { BaseLoadingStatus } from '@lumapps/utils/types/BaseLoadingStatus';

export interface ProgramIdsByName {
    [name: string]: string;
}

export interface ProgramSelectionModalState {
    modalStatus: BaseLoadingStatus;
    programIdsByName: ProgramIdsByName;
}

export const programSelectionModalInitialState = {
    programIdsByName: {},
    modalStatus: BaseLoadingStatus.initial,
};

const { actions, reducer } = createSlice({
    domain: 'ProgramForm/ProgramSelectionModal',
    initialState: programSelectionModalInitialState,
    reducers: {
        setProgramIdsByName: (state: ProgramSelectionModalState, action: PayloadAction<ProgramIdsByName>) => {
            set(state, 'programIdsByName', action.payload);
        },
        setModalStatus: (state: ProgramSelectionModalState, action: PayloadAction<BaseLoadingStatus>) => {
            set(state, 'modalStatus', action.payload);
        },
    },
});

export { actions, reducer };
